<template>
  <v-app-bar id="core-app-bar" app color="primary" height="88">
    <v-app-bar-nav-icon @click="toggleDrawer"></v-app-bar-nav-icon>

    <v-toolbar-title class="font-weight-light align-self-center">
      <span class="navbar-title">{{ $t('global.title') }}</span>
      <span class="navbar-version">{{ version }}</span>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <div class="d-flex align-center mr-2">
      <span class="user-info">
        <div>
          {{ username }}
        </div>
        <div v-if="accountSwitched">[{{ realUserName }}]</div>
      </span>

      <v-btn icon size="40" to="/" exact>
        <v-icon>mdi-home</v-icon>
      </v-btn>

      <Cart v-if="isOrgUser" />

      <v-btn v-if="authenticated" icon size="40" @click="profileDialogOpen = true">
        <v-icon>mdi-account-circle</v-icon>
      </v-btn>

      <user-profile-dialog v-if="authenticated" v-model="profileDialogOpen" />

      <!-- menu z jezykami -->
      <v-menu location="bottom left" transition="slide-y-transition">
        <template v-slot:activator="{ props }">
          <v-btn class="toolbar-items" icon size="40" v-bind="props">
            {{ currentLanguage }}
          </v-btn>
        </template>

        <v-card>
          <v-list density="compact">
            <v-list-item
              v-for="(value, key) in languages"
              :key="`lang-${key}`"
              @click="changeLanguage(key)"
              :class="{ active: isActiveLanguage(key) }"
            >
              <v-list-item-title>{{ value.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </div>
  </v-app-bar>
</template>

<script setup lang="ts">
import { computed, inject, onMounted, ref } from 'vue';
import { VERSION } from '@/constants';
import TranslationService from '@/locale/translation.service';
import { useTranslationStore } from '@/stores/translation';
import { useAppStateStore } from '@/stores/appState';
import { useAccountStore } from '@/stores/account';
import UserProfileDialog from '@/venit/user/profile/user-profile-dialog.vue';
import Cart from '@/venit/components/cortona-venit/components/cart/Cart.vue';

const translationService = inject<() => TranslationService>('translationService')!;
const translationStore = useTranslationStore();
const appStateStore = useAppStateStore();
const accountStore = useAccountStore();

const version = VERSION && VERSION != 'UNKNOWN' ? 'v' + VERSION : '';
const profileDialogOpen = ref(false);

const languages = computed(() => translationStore.languages);
const currentLanguage = computed(() => translationStore.currentLanguage);
const username = computed(() => accountStore.account ? accountStore.account.email : '');
const authenticated = computed(() => accountStore.authenticated);
const isOrgUser = computed(() => authenticated.value && accountStore.account?.userType === 'ORGANIZATION_USER');
const accountSwitched = computed(() => accountStore.accountSwitched);
const realUserName = computed(() => accountStore.realUserName);

const changeLanguage = (newLanguage: string): void => {
  translationService().refreshTranslation(newLanguage);
};

const isActiveLanguage = (key: string): boolean => {
  return key === translationStore.currentLanguage;
};

const toggleDrawer = (): void => {
  appStateStore.setDrawer(!appStateStore.drawer);
};

onMounted(() => {
  translationService().refreshTranslation(currentLanguage.value);
});
</script>

<style scoped>
.navbar-title {
  display: inline-block;
  vertical-align: middle;
}

.navbar-version {
  font-size: 10px;
  color: #ccc;
}

.user-info {
  font-size: 0.8rem;
  color: #ccc;
  padding: 1rem;
}

#core-app-bar {
  width: auto;
}
</style>
